import { FC, useState } from 'react';
import styles from './CourseSwitch.module.scss';

interface SwitchProps {
  checked: boolean;
  onClick: () => void;
}

const Switch:FC<SwitchProps> = ({
  checked,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {}
}) => {
  const [checkedState, setCheckedState] = useState<boolean>(checked);
  const handleChange = () => {
    setCheckedState(!checkedState)
    onClick()
  }
  
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={checkedState}
        onChange={handleChange}
        className={styles.input}
      />
      <span className={styles.slider}></span>
    </label>
  );
};

export default Switch;
